import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=6a17695a&scoped=true"
var script = {}
import style0 from "./Container.vue?vue&type=style&index=0&id=6a17695a&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17695a",
  null
  
)

export default component.exports